<p class="title">
    <img class="icon-title" src="assets/images/edit.svg" alt="Image" />
    {{ texts.titulo }}
  </p>
  <div class="container">
    <div id="mainDiv" class="main-div form-div">
      <div id="mainDiv" class="form-container">
        <div class="form-column">
          <div class="form-item">
            <label>{{ texts.observacao }}</label>
            <input [(ngModel)]="form.observacao" type="text" pInputText [placeholder]="placeholders.observacao" />
          </div>
          <div class="form-item">
            <label>{{ texts.tipo_despesa }}</label>
            <p-dropdown
              [options]="tipoDespesaOptions"
              optionLabel="label"
              [placeholder]="placeholders.selecione"
              [(ngModel)]="form.tipoDespesa"
            ></p-dropdown>
          </div>
          <div class="form-item">
            <label>{{ texts.conta_origem }}</label>
            <p-dropdown
              [options]="contasOptions"
              optionLabel="label"
              [placeholder]="placeholders.selecione"
              [(ngModel)]="form.conta_id"
            >
              <ng-template pTemplate="selectedItem" let-conta>
                <div class="dropdown-conta-item" *ngIf="conta">
                  <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
                  <span>{{ conta.label }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="item" let-conta>
                <div class="dropdown-conta-item">
                  <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
                  <span>{{ conta.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="form-item">
            <label>{{ texts.pessoa_fornecedor }}</label>
            <p-dropdown
              [options]="clientesOptions"
              optionLabel="nome"
              optionValue="id"
              [placeholder]="placeholders.selecionar_pessoa"
              [(ngModel)]="form.pessoa_id"
              [filter]="true"
              filterBy="nome"
              [showClear]="true"
              appendTo="body"
            ></p-dropdown>
          </div>
        </div>

        <div class="form-column">
          <div class="form-item">
            <label>{{ texts.moeda }}</label>
            <p-dropdown
              [options]="moedas"
              optionLabel="label"
              [placeholder]="placeholders.selecione"
              [(ngModel)]="form.moedaDeOrigem"
            ></p-dropdown>
          </div>
          <div class="form-item">
            <label>{{ texts.conta_destino }}</label>
            <p-dropdown
              [options]="contasOptions"
              optionLabel="label"
              [placeholder]="placeholders.selecione"
              [(ngModel)]="form.contaDestino_id"
            >
              <ng-template pTemplate="selectedItem" let-conta>
                <div class="dropdown-conta-item" *ngIf="conta">
                  <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
                  <span>{{ conta.label }}</span>
                </div>
              </ng-template>
              <ng-template pTemplate="item" let-conta>
                <div class="dropdown-conta-item">
                  <img *ngIf="conta.flagUrl" [src]="conta.flagUrl" class="flag-icon-small" alt="" />
                  <span>{{ conta.label }}</span>
                </div>
              </ng-template>
            </p-dropdown>
          </div>
          <div class="form-item">
            <label>{{ texts.valor }}</label>
            <div class="currency-input-container">
              <input
                [value]="valorStrs['valor']"
                type="text"
                pInputText
                [placeholder]="placeholders.valor"
                (input)="formataCampoValor($event, 'valor')"
                class="currency-input-with-symbol"
              />
              <span class="currency-symbol-inside-input">{{ getSymbolMoeda() }}</span>
            </div>
          </div>
          <div class="form-column">
            <div class="form-item">
              <label>{{ texts.valor_recebido_na_conta }}</label>
              <div class="currency-input-container">
                <input
                  [value]="valorStrs['valorRecebidoNaConta']"
                  type="text"
                  pInputText
                  [placeholder]="placeholders.valor_recebido_na_conta"
                  (input)="formataCampoValor($event, 'valorRecebidoNaConta')"
                  class="currency-input-with-symbol"
                />
                <span class="currency-symbol-inside-input">{{ getSymbolMoeda() }}</span>
              </div>
            </div>
            <!--
              Cards de valores recebidos por moeda — migrado para o sub-componente
              compartilhado (spec 06-financeiro-multimoeda-fix). Suporta PESO
              automaticamente quando empresa for ARS e cotPesoGuarani > 0.
            -->
            <div class="form-item form-item--cards-pagamento">
              <app-forma-pagamento-cards
                [moedaPadrao]="moedaEmpresa"
                [cotPYG]="cotPYG"
                [cotBRL]="cotBRL"
                [cotPesoGuarani]="cotPesoGuarani"
                [cotRealGuarani]="cotRealGuarani"
                [(valores)]="formValores"
                [mostrarTroco]="false">
              </app-forma-pagamento-cards>
            </div>
          </div>
        </div>
        <div class="actions-container">
          <button pButton [label]="botoes.salvar" icon="pi pi-check" (click)="submit()" class="btn-primary"></button>
        </div>
      </div>
    </div>
  </div>
